package app.footyguide.web.components.club

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import app.footyguide.core.theme.Club
import app.footyguide.web.components.CrestSizes
import app.footyguide.web.components.Icons
import app.footyguide.web.components.SafeImg

/**
 * Editorial Hero Banner for Club presentation.
 */
@Composable
fun ClubHeroBanner(club: Club) {
    Div({
        style {
            margin(16.px, 16.px, 8.px)
            backgroundColor(Color("#FFFFFF"))
            border(1.px, LineStyle.Solid, Color("#E7E7E1"))
            property("border-top", "4px solid ${club.c1}")
            borderRadius(18.px)
            padding(20.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(16.px)
            property("box-shadow", "0 2px 8px rgba(22, 24, 29, 0.04)")
        }
    }) {
        Div({
            style {
                width(64.px)
                height(64.px)
                minWidth(64.px)
                borderRadius(16.px)
                backgroundColor(Color("#FAFAF7"))
                border(1.px, LineStyle.Solid, Color("#E7E7E1"))
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
            }
        }) {
            SafeImg(
                src = club.logoUrl,
                fallbackIcon = Icons.SHIELD,
                fallbackSize = CrestSizes.DETAIL_HEADER_FALLBACK,
                modifier = {
                    width(CrestSizes.DETAIL_HEADER_PX.px)
                    height(CrestSizes.DETAIL_HEADER_PX.px)
                    property("width", CrestSizes.DETAIL_HEADER_CSS)
                    property("height", CrestSizes.DETAIL_HEADER_CSS)
                    property("object-fit", "contain")
                }
            )
        }

        Div({ style { flex(1) } }) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(8.px)
                }
            }) {
                H2({
                    style {
                        margin(0.px)
                        fontFamily("Sora, sans-serif")
                        fontSize(20.px)
                        fontWeight(800)
                        color(Color("#16181D"))
                        letterSpacing((-0.4).px)
                    }
                }) {
                    Text(club.name)
                }
                Span({
                    style {
                        fontSize(11.px)
                        fontWeight(800)
                        fontFamily("Inter, sans-serif")
                        backgroundColor(Color("#F4F4F5"))
                        color(Color("#71717A"))
                        padding(2.px, 6.px)
                        borderRadius(4.px)
                    }
                }) {
                    Text(club.initials)
                }
            }
            Span({
                style {
                    display(DisplayStyle.Block)
                    marginTop(3.px)
                    fontFamily("Inter, sans-serif")
                    fontSize(12.px)
                    color(Color("#71717A"))
                    fontWeight(500)
                }
            }) {
                Text(club.fullName)
            }
        }
    }
}
